module.exports = __webpack_public_path__ + "static/media/lightbulb.9825b8e6.gif";